import {
  Card,
  CardContent,
} from '@eriko/ui/src/components/ui/card';

export function GenericArtifactView({ data }: { data: Record<string, unknown> }) {
  return (
    <Card>
      <CardContent className="p-3">
        <pre className="text-xs whitespace-pre-wrap break-all text-muted-foreground">
          {JSON.stringify(data, null, 2)}
        </pre>
      </CardContent>
    </Card>
  );
}

export function SummaryTextView({ summary }: { summary: string }) {
  return (
    <Card>
      <CardContent className="p-3">
        <p className="text-sm leading-relaxed">{summary}</p>
      </CardContent>
    </Card>
  );
}
